import jQuery from 'jquery';
import 'slick-carousel';
/* eslint-disable no-console */
const StatSlider = {
  onReady: () => {
    // eslint-disable-next-line no-unused-vars
    (function ($) {
      $('.site-content .stats-slider__wrapper').slick({
        dots: true,
        arrows: false,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 5000,
      });
    })(jQuery);
  },
};

export default StatSlider;
